import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "extensionBar" }
const _hoisted_2 = { class: "loginRow" }
const _hoisted_3 = { class: "loginData" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "loginRow" }
const _hoisted_6 = { class: "loginData expired" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_visible = _resolveDirective("visible")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode($setup["VolumesOverlay"], {
      onHide: _cache[0] || (_cache[0] = ($event: any) => ($setup.showVolumes = false))
    }, null, 512 /* NEED_PATCH */), [
      [_directive_visible, $setup.showVolumes]
    ]),
    _withDirectives(_createVNode($setup["UserProfile"], {
      onHide: _cache[1] || (_cache[1] = ($event: any) => ($setup.showUserProfile = false))
    }, null, 512 /* NEED_PATCH */), [
      [_directive_visible, $setup.showUserProfile]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"ng-extend-logo\"><a href=\"https://pyr.ai/\" target=\"_blank\"><img class=\"pyr-logo-gem\" src=\"insert-img\" title=\"Pyr\" width=\"15\"><img class=\"pyr-logo-text\" src=\"insert-img\" title=\"Pyr\" width=\"40\"></a></div><div id=\"insertNGTopBar\" class=\"flex-fill\"></div>", 2)),
      _createCommentVNode(" <button v-if=\"volumes.length\" @click=\"showVolumes = true\">\r\n      Volumes ({{ volumes.length }})\r\n    </button> "),
      ($setup.login.sessions.length > 0)
        ? (_openBlock(), _createBlock($setup["DropdownList"], {
            key: 0,
            "dropdown-group": "extension-bar-right",
            id: "loginsDropdown",
            class: "rightMost"
          }, _createSlots({
            listItems: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.validLogins, (session) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", null, _toDisplayString(session.email), 1 /* TEXT */),
                      _createElementVNode("div", null, _toDisplayString(session.hostname), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", {
                      class: "viewProfileButton button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showUserProfile = true))
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("span", null, "Profile", -1 /* HOISTED */)
                    ]))]),
                    _createElementVNode("div", {
                      class: "logoutButton button",
                      onClick: ($event: any) => ($setup.logout(session))
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", null, "Logout", -1 /* HOISTED */)
                    ]))], 8 /* PROPS */, _hoisted_4)
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invalidLogins, (session) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, _toDisplayString(session.hostname) + " - Expired", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", {
                      class: "logoutButton",
                      onClick: ($event: any) => ($setup.logout(session))
                    }, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("span", null, "Delete", -1 /* HOISTED */)
                    ]))], 8 /* PROPS */, _hoisted_7)
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]),
            _: 2 /* DYNAMIC */
          }, [
            ($setup.login.sessions.length === 1)
              ? {
                  name: "buttonTitle",
                  fn: _withCtx(() => [
                    _createTextVNode("👤 " + _toDisplayString($setup.validLogins[0].name), 1 /* TEXT */)
                  ]),
                  key: "0"
                }
              : {
                  name: "buttonTitle",
                  fn: _withCtx(() => [
                    _createTextVNode("Logins (" + _toDisplayString($setup.login.sessions.length) + ")", 1 /* TEXT */)
                  ]),
                  key: "1"
                }
          ]), 1024 /* DYNAMIC_SLOTS */))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["DropdownList"], {
        "dropdown-group": "extension-bar-right",
        id: "hamburger",
        class: "rightMost"
      }, {
        buttonTitle: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("☰")
        ])),
        listItems: _withCtx(() => [
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.tutorialStep = 0))
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("span", null, "Reset Tutorial", -1 /* HOISTED */)
            ]))
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "logoutButton button" }, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: "https://forum.eyewire.org"
                }, "Forum")
              ])
            ])
          ], -1 /* HOISTED */)),
          _cache[10] || (_cache[10] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "logoutButton button" }, [
              _createElementVNode("span", null, "Quickstart Guide")
            ])
          ], -1 /* HOISTED */)),
          _cache[11] || (_cache[11] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "logoutButton button" }, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: "https://blog.pyr.ai/2024/12/20/proofreading-101-climb-into-spelunker/"
                }, "Proofreading Guide")
              ])
            ])
          ], -1 /* HOISTED */)),
          _cache[12] || (_cache[12] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "logoutButton button" }, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: "https://youtu.be/48GS9Sizrvw"
                }, "Merge")
              ])
            ])
          ], -1 /* HOISTED */)),
          _cache[13] || (_cache[13] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "logoutButton button" }, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: "https://youtu.be/DB6wmQWGsck"
                }, "Split")
              ])
            ])
          ], -1 /* HOISTED */)),
          _cache[14] || (_cache[14] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "logoutButton button" }, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: "https://youtu.be/CGooeAhSryg"
                }, "Find path")
              ])
            ])
          ], -1 /* HOISTED */)),
          _cache[15] || (_cache[15] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "logoutButton button" }, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: "https://www.youtube.com/playlist?list=PLZlCbXsRJFCw0BLFWKrc49JHKWK1o41Ud"
                }, "Advanced Videos")
              ])
            ])
          ], -1 /* HOISTED */)),
          _cache[16] || (_cache[16] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "logoutButton button" }, [
              _createElementVNode("span", null, "Cells to Map")
            ])
          ], -1 /* HOISTED */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 64 /* STABLE_FRAGMENT */))
}